/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=19288c30"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=19288c30&lang=scss"

import exportComponent from "E:\\work\\品尚官网\\pszx-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__